var _defs, _polygon, _polygon2, _rect, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _line, _text, _circle, _line2, _text2, _circle2, _line3, _text3, _circle3, _text4, _circle4, _line4, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIvm1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:#812990;}.cls-2{fill:#d5ddeb;}.cls-3,.cls-5{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-3{stroke-dasharray:2 2;}.cls-4{fill:#fff;}.cls-6{font-size:8px;font-family:ProximaNova-Regular, Proxima Nova;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "308.16 346.84 363.43 254.72 418.71 346.84 308.16 346.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "418.71 162.59 50.2 162.59 50.2 346.84 308.16 346.84 418.71 162.59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87.06,
    y: 52.04,
    width: 294.8,
    height: 92.13
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.57 402.14 234.42 346.86 50.17 346.86 50.17 402.14 197.57 402.14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.15,391.5v.71H87v-4.06h3v.71h-2.2v1h1.84v.7H87.83v.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.51,387.86v4.35h-.8V392a1.88,1.88,0,0,1-.92.24,1.62,1.62,0,0,1,0-3.24,2,2,0,0,1,.92.24v-1.4Zm-.8,3.41V390a1.22,1.22,0,0,0-.77-.27.9.9,0,0,0-.94.9.89.89,0,0,0,.94.9A1.22,1.22,0,0,0,93.71,391.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.85,389.08v3.13h-.8V392a1.45,1.45,0,0,1-.85.26c-.92,0-1.34-.43-1.34-1.44v-1.74h.8v1.74c0,.48.23.72.68.72a1.06,1.06,0,0,0,.71-.25v-2.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103,391.63a1.52,1.52,0,0,1-1.22.63,1.62,1.62,0,1,1,0-3.24,1.53,1.53,0,0,1,1.23.63l-.52.48a.85.85,0,0,0-.71-.39.9.9,0,1,0,0,1.8.85.85,0,0,0,.71-.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.36,389.08v3.13h-.8V392a1.67,1.67,0,0,1-.92.28,1.62,1.62,0,0,1,0-3.24,1.82,1.82,0,0,1,.92.26v-.2Zm-.8.94a1.22,1.22,0,0,0-.78-.28.9.9,0,1,0,0,1.8,1.19,1.19,0,0,0,.78-.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.72,389.74v1.11c0,.56.09.72.49.72a2.05,2.05,0,0,0,.37,0v.6a1.87,1.87,0,0,1-.72.12.9.9,0,0,1-1-1v-1.53h-.44v-.66h.44v-1.22h.81v1.22h.88v.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.72,388.27a.47.47,0,0,1,.47-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,111.72,388.27Zm.07.81h.8v3.13h-.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.26,390.64a1.72,1.72,0,1,1-1.71-1.62A1.67,1.67,0,0,1,117.26,390.64Zm-.79,0a.93.93,0,1,0-.92.9A.91.91,0,0,0,116.47,390.64Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.47,390.47v1.74h-.8v-1.74c0-.49-.24-.73-.68-.73a1,1,0,0,0-.69.25v2.22h-.81v-3.13h.81v.2a1.46,1.46,0,0,1,.83-.26C121.05,389,121.47,389.45,121.47,390.47Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.83,390.41a7.6,7.6,0,0,1-.62.93l.49.47-.48.45-.45-.45a1.71,1.71,0,0,1-1.08.45c-.94,0-1.54-.44-1.54-1.18A1.22,1.22,0,0,1,126,390a1.08,1.08,0,0,1-.36-.79,1.15,1.15,0,0,1,2.3-.08,1.25,1.25,0,0,1-.87,1.11l.69.66a4.31,4.31,0,0,0,.48-.67Zm-1.48.95-.91-.88c-.33.13-.48.33-.48.57s.27.56.76.56A1,1,0,0,0,127.35,391.36Zm-1-2.13c0,.3.25.47.36.58.26-.08.6-.27.6-.59a.49.49,0,0,0-.49-.54A.52.52,0,0,0,126.32,389.23Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.51,388.15h.91l-1.9,4.06h-.39l-1.89-4.06h.9l1.19,2.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.43,388.27a.46.46,0,1,1,.46.47A.47.47,0,0,1,137.43,388.27Zm.06.81h.8v3.13h-.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.82,391.36a2.52,2.52,0,0,0,1.08.26c.37,0,.51-.14.51-.3s-.18-.26-.66-.36c-.68-.15-1.17-.37-1.17-1s.47-1,1.2-1a3.1,3.1,0,0,1,1.22.26l-.26.59a2.87,2.87,0,0,0-1-.21c-.31,0-.46.11-.46.28s.19.25.69.36c.73.15,1.15.4,1.15,1s-.46,1-1.26,1a2.85,2.85,0,0,1-1.36-.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.51,389.08v3.13h-.81V392a1.66,1.66,0,0,1-.91.28,1.62,1.62,0,0,1,0-3.24,1.76,1.76,0,0,1,.91.26v-.2Zm-.81.94a1.17,1.17,0,0,0-.77-.28.9.9,0,1,0,0,1.8,1.14,1.14,0,0,0,.77-.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.53,391c0,.78-.63,1.24-1.58,1.24a3.18,3.18,0,0,1-1.69-.38l.3-.64a2.91,2.91,0,0,0,1.42.31c.45,0,.71-.16.71-.46s-.27-.4-.86-.54c-.84-.19-1.52-.42-1.52-1.23s.58-1.22,1.51-1.22a4,4,0,0,1,1.55.33l-.33.66a3.59,3.59,0,0,0-1.24-.27c-.42,0-.65.18-.65.43s.29.41.9.55C152.93,390,153.53,390.27,153.53,391Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.43,390.87a.87.87,0,0,0,.9.7,1,1,0,0,0,.81-.38l.51.42a1.74,1.74,0,0,1-1.42.65,1.62,1.62,0,0,1,0-3.24,1.51,1.51,0,0,1,1.53,1.68c0,.06,0,.12,0,.17Zm0-.51H157a.69.69,0,0,0-.76-.7A.82.82,0,0,0,155.44,390.36Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.79,389.52a1.24,1.24,0,0,1,1-.5.79.79,0,0,1,.2,0v.87a2.14,2.14,0,0,0-.39-.05.75.75,0,0,0-.8.82v1.51H159v-3.13h.81Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.27,389.08l-1.5,3.13h-.38l-1.51-3.13h.85l.85,1.78.85-1.78Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.34,388.27a.46.46,0,1,1,.46.47A.47.47,0,0,1,166.34,388.27Zm.06.81h.8v3.13h-.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.38,391.63a1.5,1.5,0,0,1-1.21.63,1.62,1.62,0,1,1,0-3.24,1.51,1.51,0,0,1,1.22.63l-.52.48a.82.82,0,0,0-.7-.39.9.9,0,1,0,0,1.8.82.82,0,0,0,.7-.39Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.15,390.87a.87.87,0,0,0,.9.7,1,1,0,0,0,.81-.38l.51.42a1.73,1.73,0,0,1-1.41.65,1.62,1.62,0,0,1,0-3.24,1.51,1.51,0,0,1,1.52,1.68c0,.06,0,.12,0,.17Zm0-.51h1.55a.69.69,0,0,0-.75-.7A.82.82,0,0,0,173.16,390.36Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.83,391.36a2.52,2.52,0,0,0,1.08.26c.37,0,.51-.14.51-.3s-.18-.26-.66-.36c-.68-.15-1.17-.37-1.17-1s.47-1,1.2-1a3.1,3.1,0,0,1,1.22.26l-.27.59a2.77,2.77,0,0,0-1-.21c-.31,0-.46.11-.46.28s.19.25.69.36c.73.15,1.15.4,1.15,1s-.46,1-1.26,1a2.85,2.85,0,0,1-1.36-.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.33,357.19h-.78v2.18h-.45v-2.18h-.77v-.45h2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.15,356.74v2.63h-.45V357.5l-.87,1.35L177,357.5v1.87h-.45v-2.63h.5l.82,1.28.83-1.28Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107,363.56v.85a6.3,6.3,0,0,0-1.5-.8,5.34,5.34,0,0,0-1.94-.32,5.76,5.76,0,0,0-2.26.43,5.46,5.46,0,0,0-1.8,1.2,5.38,5.38,0,0,0-1.18,1.78,5.69,5.69,0,0,0,0,4.34,5.38,5.38,0,0,0,1.18,1.78,5.46,5.46,0,0,0,1.8,1.2,5.76,5.76,0,0,0,2.26.43h.22A6,6,0,0,0,106,374v-3h0a3.08,3.08,0,0,1-1,.67,3.39,3.39,0,0,1-1.23.22,4.55,4.55,0,0,1-.52,0h0a3.79,3.79,0,0,1-.72-.18,3,3,0,0,1-1-5,3.25,3.25,0,0,1,1-.66,3.49,3.49,0,0,1,1.24-.23,3.2,3.2,0,0,1,2.28.89,2.88,2.88,0,0,1,.94,2.16v5.57h2.67V363.56Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.63,374.45l-5.93-5.72v5.72H87V359.37H89.7v5.7l5.93-5.68h3.8L91.6,366.9l7.83,7.55Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.6,363.29a4.94,4.94,0,0,1,2,.39,4.48,4.48,0,0,1,1.52,1.08,4.79,4.79,0,0,1,1,1.6,5.48,5.48,0,0,1,.34,1.95v6.14h-2.67v-6.14a2.27,2.27,0,0,0-.79-1.76,2.54,2.54,0,0,0-1.82-.72,2.61,2.61,0,0,0-1.86.72,2.35,2.35,0,0,0-.75,1.76v6.14h-2.68V363.58h2.68v.81a5.21,5.21,0,0,1,1.36-.79A4.35,4.35,0,0,1,116.6,363.29Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.88,363.58a4.85,4.85,0,0,1,1.8-.31v2.54a3.22,3.22,0,0,0-2.28.89,3,3,0,0,0-.93,2.16v5.59h-2.68V363.56h2.68v.83A6,6,0,0,1,152.88,363.58Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.73,363.29a6,6,0,0,1,2.3.43,5.93,5.93,0,0,1,1.88,1.2,5.76,5.76,0,0,1,1.26,1.78,5.46,5.46,0,0,1,0,4.34,5.76,5.76,0,0,1-1.26,1.78A5.93,5.93,0,0,1,163,374a6.34,6.34,0,0,1-4.59,0,5.93,5.93,0,0,1-1.88-1.2A5.76,5.76,0,0,1,155.3,371a5.46,5.46,0,0,1,0-4.34,5.76,5.76,0,0,1,1.26-1.78,5.93,5.93,0,0,1,1.88-1.2A6,6,0,0,1,160.73,363.29Zm0,2.54a3.18,3.18,0,0,0-2.27.89,3,3,0,0,0,1,5,3.39,3.39,0,0,0,1.23.22,3.36,3.36,0,0,0,1.23-.22,3.08,3.08,0,0,0,1-.67,2.93,2.93,0,0,0,0-4.3A3.29,3.29,0,0,0,160.73,365.83Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.26,363.29a6.07,6.07,0,0,1,2.3.43,5.88,5.88,0,0,1,1.87,1.2,5.45,5.45,0,0,1,1.26,1.78,5.35,5.35,0,0,1,0,4.34,5.45,5.45,0,0,1-1.26,1.78,5.88,5.88,0,0,1-1.87,1.2,6.37,6.37,0,0,1-4.6,0,5.88,5.88,0,0,1-1.87-1.2,5.45,5.45,0,0,1-1.26-1.78,5.35,5.35,0,0,1,0-4.34,5.45,5.45,0,0,1,1.26-1.78,5.88,5.88,0,0,1,1.87-1.2A6.07,6.07,0,0,1,173.26,363.29Zm0,2.54a3.22,3.22,0,0,0-2.28.89,3,3,0,0,0,0,4.3,3,3,0,0,0,1,.67,3.49,3.49,0,0,0,1.24.22,3.39,3.39,0,0,0,1.23-.22,3.14,3.14,0,0,0,1-.67,2.93,2.93,0,0,0,0-4.3A3.28,3.28,0,0,0,173.26,365.83Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.63,363.56v.85a6,6,0,0,0-1.49-.8,5.34,5.34,0,0,0-1.94-.32,5.81,5.81,0,0,0-2.27.43,5.42,5.42,0,0,0-1.79,1.2A5.56,5.56,0,0,0,136,366.7a5.82,5.82,0,0,0,0,4.34,5.56,5.56,0,0,0,1.19,1.78,5.42,5.42,0,0,0,1.79,1.2,5.81,5.81,0,0,0,2.27.43h.22a6.06,6.06,0,0,0,2.29-.43v-3h0a3.29,3.29,0,0,1-1,.67,3.39,3.39,0,0,1-1.23.22,4.38,4.38,0,0,1-.52,0h0a3.79,3.79,0,0,1-.72-.18,3,3,0,0,1-1-5,3.25,3.25,0,0,1,1-.66,3.49,3.49,0,0,1,1.24-.23,3.22,3.22,0,0,1,2.28.89,2.87,2.87,0,0,1,.93,2.16v5.57h2.68V363.56Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.66,363.56v.85a5.94,5.94,0,0,0-1.5-.8,4.18,4.18,0,0,0-1-.25,6.88,6.88,0,0,0-1.15-.09,5.6,5.6,0,0,0-2.22.43,5.31,5.31,0,0,0-1.74,1.2,5.54,5.54,0,0,0-1.12,1.78,5.83,5.83,0,0,0-.4,2.18h0A5.62,5.62,0,0,0,123,371a5.44,5.44,0,0,0,3,3,5.8,5.8,0,0,0,2.26.43h.4a5.75,5.75,0,0,0,2.11-.42v-3h0a3.08,3.08,0,0,1-1.05.67,3.3,3.3,0,0,1-1.22.22,4.38,4.38,0,0,1-.52,0h0a3.45,3.45,0,0,1-.72-.18,2.86,2.86,0,0,1-1-.67,2.91,2.91,0,0,1-.94-2.15,3.25,3.25,0,0,1,.22-1.13.2.2,0,0,0,0-.08,3,3,0,0,1,.68-.94,3.29,3.29,0,0,1,1-.66,3.41,3.41,0,0,1,1.24-.23,3.18,3.18,0,0,1,2.27.89,3,3,0,0,1,.68.94l0,.08a3,3,0,0,1,.22,1.14v4.24a2.85,2.85,0,0,1-.94,2.14,3.08,3.08,0,0,1-2.27.91,3.12,3.12,0,0,1-1.61-.42l-1.94,1.82a5.84,5.84,0,0,0,1.65.84,5.91,5.91,0,0,0,1.9.3,6,6,0,0,0,2.29-.44,6.13,6.13,0,0,0,1.88-1.21,5.76,5.76,0,0,0,1.26-1.78,5.3,5.3,0,0,0,.46-2.16v-9.56Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.13,383.66v.71H87v-4.05h3V381H87.82v1h1.84v.69H87.82v.91Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.27,380v4.33h-.81v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.92,1.92,0,0,1,.91.24V380Zm-.81,3.39v-1.25a1.19,1.19,0,0,0-.76-.27.89.89,0,0,0-.93.9.87.87,0,0,0,.93.89A1.14,1.14,0,0,0,94.46,383.38Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.37,381.21v3.12h-.8v-.21a1.49,1.49,0,0,1-.85.25c-.91,0-1.33-.42-1.33-1.43v-1.73h.8v1.73c0,.48.23.72.68.72a1.08,1.08,0,0,0,.7-.25v-2.2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.29,383.75a1.5,1.5,0,0,1-1.2.62,1.61,1.61,0,1,1,0-3.22,1.49,1.49,0,0,1,1.21.62l-.51.48a.86.86,0,0,0-.7-.38.9.9,0,1,0,0,1.79.85.85,0,0,0,.7-.39Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.42,381.21v3.12h-.8v-.23a1.66,1.66,0,0,1-.92.27,1.62,1.62,0,0,1,0-3.23,1.93,1.93,0,0,1,.92.26v-.19Zm-.8.93a1.2,1.2,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.18,1.18,0,0,0,.77-.27Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.55,381.87V383c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2.06,2.06,0,0,1-.72.11.9.9,0,0,1-1-1v-1.52h-.44v-.66h.44V380h.81v1.22h.87v.66Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.33,380.45a.46.46,0,1,1,.92,0,.46.46,0,0,1-.92,0Zm.06.8h.8v3.12h-.8Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.63,382.76a1.71,1.71,0,1,1-1.71-1.61A1.65,1.65,0,0,1,122.63,382.76Zm-.79,0a.9.9,0,0,0-.92-.89.9.9,0,1,0,.92.89Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.61,382.63v1.74h-.8v-1.74c0-.48-.23-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.46,1.46,0,0,1,.84-.25C127.19,381.2,127.61,381.62,127.61,382.63Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.88,381v1.45h1.94v.71h-1.94v1.18h-.8v-4.05h3.06V381Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.3,382.76a1.71,1.71,0,1,1-1.71-1.61A1.66,1.66,0,0,1,141.3,382.76Zm-.79,0a.92.92,0,1,0-.92.9A.91.91,0,0,0,140.51,382.76Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.26,381.21v3.12h-.8v-.21a1.52,1.52,0,0,1-.85.25c-.91,0-1.33-.42-1.33-1.43v-1.73h.79v1.73c0,.48.24.72.68.72a1.09,1.09,0,0,0,.71-.25v-2.2Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.39,382.63v1.74h-.8v-1.74c0-.48-.24-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.45,1.45,0,0,1,.83-.25C151,381.2,151.39,381.62,151.39,382.63Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.66,380v4.33h-.8v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.92,1.92,0,0,1,.91.24V380Zm-.8,3.39v-1.25a1.19,1.19,0,0,0-.76-.27.9.9,0,0,0-.94.9.88.88,0,0,0,.94.89A1.15,1.15,0,0,0,155.86,383.38Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162,381.21v3.12h-.8v-.23a1.6,1.6,0,0,1-.91.27,1.62,1.62,0,0,1,0-3.23,1.86,1.86,0,0,1,.91.26v-.19Zm-.8.93a1.16,1.16,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.14,1.14,0,0,0,.77-.27Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.09,381.87V383c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2.06,2.06,0,0,1-.72.11.9.9,0,0,1-.95-1v-1.52h-.44v-.66h.44V380h.81v1.22H166v.66Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.87,380.45a.47.47,0,0,1,.46-.47.46.46,0,0,1,.45.47.45.45,0,0,1-.45.46A.46.46,0,0,1,167.87,380.45Zm.06.8h.8v3.12h-.8Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.17,382.76a1.71,1.71,0,1,1-1.71-1.61A1.65,1.65,0,0,1,174.17,382.76Zm-.79,0a.92.92,0,0,0-1.84,0,.92.92,0,0,0,1.84,0Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.15,382.63v1.74h-.8v-1.74c0-.48-.24-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.46,1.46,0,0,1,.84-.25C178.73,381.2,179.15,381.62,179.15,382.63Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 11.73,
    y1: 374.88,
    x2: 71.97,
    y2: 374.88
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(4.55 377.66)"
  }, "1")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 5.92,
    cy: 374.88,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 11.73,
    y1: 257.42,
    x2: 71.97,
    y2: 257.42
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(3.56 260.2)"
  }, "2")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 5.92,
    cy: 257.42,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 363.59,
    y1: 440.79,
    x2: 363.59,
    y2: 307.94
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(361.35 449.17)"
  }, "4")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 363.59,
    cy: 446.46,
    r: 5.67
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(134.54 8.63)"
  }, "3")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 136.78,
    cy: 5.92,
    r: 5.67
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 136.77,
    y1: 51.56,
    x2: 136.77,
    y2: 11.63
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvm1);
export default __webpack_public_path__ + "static/media/ivm1.57153da7711ae2f37723a2ec6d93b770.svg";
export { ForwardRef as ReactComponent };